import { Link } from 'react-router-dom'
import { TEXTOS } from '../../../lib/glossario'

/**
 * A pauta de conferência do mês: quantos chamados têm cada ponto apontado pela análise.
 *
 * É o que tira o alerta do detalhe de cada chamado e o coloca onde a decisão acontece. "5 chamados
 * com Pendente usado para parar o relógio" no fechamento é uma lista de trabalho; o mesmo aviso
 * dentro de um chamado era invisível para quem não o abrisse — e o fiscal de maio anotou esse
 * padrão cinco vezes à mão.
 *
 * Cada linha é um link para a listagem já filtrada: o número leva direto aos chamados que o
 * formaram, que é a mesma regra dos numeradores dos indicadores.
 *
 * **Lista vazia não some da tela, e essa é a mudança.** Antes o cartão devolvia `null` quando não
 * havia achado nenhum, e os dois casos opostos — "nada foi lido" e "foi lido e nada se achou" —
 * ficavam idênticos: uma ausência. Quem chegasse para assinar leria silêncio como mês limpo. Agora
 * o cartão diz que a leitura não apontou nada NOS CHAMADOS QUE LEU, e a cobertura, logo acima,
 * informa quantos foram.
 *
 * @param props a competência e a consolidação vinda do fechamento
 * @returns o cartão de alertas
 */
export function AlertasDaCompetencia({
  competencia,
  alertas,
}: {
  competencia: string
  alertas: { codigo: string; chamados: number }[]
}) {
  const rotulos = TEXTOS.alertasDaIa.codigos as Record<string, string>

  return (
    <section className="cartao p-5" aria-label={TEXTOS.alertasDaIa.rotulo}>
      <h2 className="text-base font-semibold text-slate-900">{TEXTOS.alertasDaIa.rotulo}</h2>
      <p className="mt-1 max-w-prose text-sm text-slate-500">{TEXTOS.alertasDaIa.ajuda}</p>
      {alertas.length === 0 && <p className="mt-3 max-w-prose text-sm text-slate-600">{TEXTOS.alertasDaIa.nenhum}</p>}
      <ul className="mt-3 space-y-1.5">
        {alertas.map((alerta) => (
          <li key={alerta.codigo} className="flex flex-wrap items-baseline gap-2 text-sm">
            <span className="font-semibold tabular-nums text-slate-900">{alerta.chamados}</span>
            <Link
              to={`/chamados?competencia=${encodeURIComponent(competencia)}&alertaDaIa=${encodeURIComponent(alerta.codigo)}`}
              className="text-niteroi-700 underline underline-offset-2 hover:text-niteroi-900"
            >
              {rotulos[alerta.codigo] ?? alerta.codigo}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}
